import { useDispatch, useSelector } from "react-redux";
import apiTransport from "../../../api/transport/apiTransport";
import { IGetParamsGET_VEH_COORDS, IVehicle } from "../../../api/transport/types";
import { RootState } from "@/store/redux/store";
import { setBoundsMap, setTransports, setVehTransports, setViewPortMapMode } from "../store/mapScreenSlce";
import useToastMap from "./useToast";
import { getMapBoundsForVehicles } from "../utils/map";

function useTransport() {
    const { city } = useSelector((state: RootState) => state.mapScreen);
    const dispatch = useDispatch();
    const { openToastMap, hideToastMap } = useToastMap();

    async function fetchTransportById({ NVEH_ID, NPART_ID, NCITY_ID }: IGetParamsGET_VEH_COORDS) {
        try {
            const res = await apiTransport.getLocationTransport({
                NVEH_ID,
                NPART_ID,
                NCITY_ID,
            });
            return res.veh_coords[NVEH_ID];

        }
        catch (err) {
            console.error(err);
        }
    }

    async function fetchAllTransport() {
        const res = await apiTransport.getAllTransportOnCity({ city_id: city.id.toString() });
        const transports = Object.values(res.vehicles);
        return transports;
    }

    async function getAllTransportOnCity(withLoadings: boolean = true, withFocus: boolean = true, succesCallback?: any, eerorCallback?: any) {
        try {
            if (withLoadings) {
                openToastMap('loading', 'Загрузка транспорта')
            }
            const transports = await fetchAllTransport();
            dispatch(setVehTransports(transports));
            if (withFocus && transports && transports.length > 0) {
                focusOnTransports(transports);
                hideToastMap();
            } else {
                if (withLoadings) {
                    openToastMap('info', 'Транспорт не обнаружен')
                    setTimeout(() => hideToastMap(), 10000)
                }
            }
            if (succesCallback) {
                succesCallback()
            }
        }
        catch (err) {
            hideToastMap();
            console.error(err);
            if (eerorCallback) {
                eerorCallback();
            }
        }
    }

    async function focusOnTransports(veh: IVehicle[]) {
        const dataBounds = getMapBoundsForVehicles(veh);
        dispatch(setViewPortMapMode('bounds'));
        dispatch(setBoundsMap({ values: dataBounds.bounds, options: dataBounds.options }));
    }

    return ({
        fetchTransportById,
        getAllTransportOnCity,
    })

}

export default useTransport;